export default __webpack_public_path__ + "static/media/content_tab03_3_03.09f176c8.png";